<!-- 物流轨迹 -->
<template>
  <div class="order-track-wrap">
    <div class="numList flex-row-start-center">
      <div style="width:60px">包裹号：</div>
      <div class="" v-if="numberList.length">
        <span
          class="no_item"
          v-for="item in numberList"
          :key="item.box_code"
          @click="getDetail(item.box_code)"
          :class="currentNo == item.box_code ? 'active' : ''"
        >
          {{ item.box_code }}
        </span>
      </div>
      <div v-else>暂无包裹</div>
    </div>
    <!-- 轨迹 -->
    <p class="order-track-title">物流轨迹：</p>
    <div v-if="list.length" v-loading>
      <!-- <div class="timeline-wrapper" v-for="item in list"> -->
      <div
        class="line-item flex-row-start-start"
        v-for="(actionItem, index) in list"
      >
        <div class="line-status">{{ actionItem.actionTagName }}</div>
        <div class="line-info">
          <div
            class="line-item-tail"
            :class="index == list.length - 1 ? 'last' : ''"
          ></div>
          <div
            class="line-item-point"
            :class="
              list.length > 1
                ? index == list.length - 1
                  ? 'last'
                  : index == 0
                  ? 'first'
                  : ''
                : 'last only_one'
            "
          >
            <span v-if="index == list.length - 1">发</span>
            <i
              class="el-icon-document"
              v-if="list.length > 1 && index == 0"
              style="color:white;"
            ></i>
          </div>
          <div class="line-content">
            {{ actionItem.actionDate }} &nbsp;&nbsp;{{ actionItem.message }}
          </div>
        </div>
      </div>
      <!-- <div class="track_no">{{ item.providerName }}</div> -->
      <!-- </div> -->
    </div>
    <div v-else class="order-track-title">暂无数据</div>
  </div>
</template>
<script>
import {
  getBoxList, //包裹列表
  getPackagetrace //物流轨迹
} from "@/models/orderModel";

export default {
  name: "orderTrack",
  props: ["order_id", "main_number", "order_type"],
  data() {
    return {
      numberList: [],
      currentNo: undefined,
      list: []
    };
  },
  watch: {
    order_id(val) {
      this.list = [];
      this.currentNo = undefined;
      // console.log("id:", val);
      if (val) {
        this.getBoxList(val);
      }
    }
  },
  created() {
    // console.log("created:", this.order_id);
    if (this.order_id) {
      this.getBoxList(this.order_id);
    }
  },
  methods: {
    // 获取所有的包裹单号
    async getBoxList(order_id) {
      const res = await getBoxList({ order_id, order_type: this.order_type });
      this.numberList = res || [];
      if (res && res.length) {
        this.getDetail(res[0].box_code);
      } else {
        this.list = [];
        this.currentNo = undefined;
      }
    },
    // 包裹详情-物流轨迹
    async getDetail(box_code) {
      if (!box_code) return;
      this.currentNo = box_code;
      this.list = [];
      const res = await getPackagetrace({
        order_id: this.order_id,
        main_number: this.main_number,
        box_code
      });
      this.list = res && res.length ? res.reverse() : [];
    }
  }
};
</script>
<style lang="scss" scoped>
.order-track-wrap {
  font-size: 14px;
  .no_item {
    display: inline-block;
    margin-right: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.45);
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    &.active {
      color: #ff6224;
      border-bottom: 1px solid #ff6224;
    }
  }
  .order-track-title {
    font-weight: bold;
  }
  .timeline-wrapper {
    margin-bottom: 20px;
  }
  .line-item {
    .line-status {
      position: relative;
      top: -3px;
      width: 70px;
      text-align: right;
      right: 10px;
    }
    .line-info {
      position: relative;
    }
    .line-item-tail {
      position: absolute;
      left: 4px;
      height: 100%;
      border-left: 1px solid rgba(0, 0, 0, 0.06);
      &.last {
        display: none;
      }
    }
    .line-item-point {
      position: absolute;
      left: 0;
      width: 8px;
      height: 8px;
      background-color: #b7b7b7;
      // border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: rotate(45deg);
      &.first {
        width: 22px;
        height: 22px;
        left: -7px;
        top: -4px;
        border-radius: 50%;
        background: #ff4d4f;
        transform: rotate(0deg);
        color: #fff;
      }
      &.last {
        width: 22px;
        height: 22px;
        left: -7px;
        top: -4px;
        border-radius: 50%;
        transform: rotate(0deg);
        color: #fff;
        // background: #ff4d4f;
      }
      &.only_one {
        background: #ff4d4f;
      }
    }
    .line-content {
      position: relative;
      padding-left: 28px;
      top: -3px;
      padding-bottom: 20px;
    }
    &:first-child {
      .line-status {
        color: #ff4d4f;
      }
    }
  }
  .track_no {
    margin-left: 90px;
    margin-bottom: 30px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/order-track.vue